import "@styles/layout.css";
import { Outlet } from "react-router-dom";

import Navbar from "@common-components/Navbar/Navbar";
import NotifyPop from "@common-components/NotifyPop/NotifyPop";

const PageNoFooterLayout = () => {
  return (
    <div className="Layout__container">
      <Navbar />
      <Outlet />
      <NotifyPop />
    </div>
  );
};
export default PageNoFooterLayout;
